import { observer } from "mobx-react-lite";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Container from 'react-bootstrap/Container';

import { Button } from "react-bootstrap";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';

import icon_person from '../Portafolio/src/imgs/person_icon.svg';
import icon_teacher from '../Portafolio/src/imgs/teacher_icon.svg';
import icon_calendar from '../Portafolio/src/imgs/calendar_icon.svg';
import icon_location from '../Portafolio/src/imgs/pinpoint_icon.svg';

import { calculoFechas } from '../Portafolio/helpers/calculoFechas';
import Pagination from 'react-bootstrap/Pagination';
import Footer from "../Footer";
import { RegionalBannerCentral } from '../Portafolio/Handlers/RegionalBannerCentral';

const apiURL = process.env.REACT_APP_API_URL;

export default observer(function DocenteCursos() {

    var pathGUID = window.location.pathname.split('/')[3];
    const url = apiURL + `/courses/GetByProfessor?Professor=${encodeURI(pathGUID)}`;
    
    const [curso, setCursos] = useState([]);
    useEffect(() => { listaCursos() }, [])


    // const listaCursos = async () => {
        
    //     const resp = await fetch ( url );
    //     const data = await resp.json();

        // let ediciones =[];
        // let ecursos ={};

        // ecursos = data.map (crs => {
        //     ediciones = crs.editions.map( edc => {
        //         return {
        //             'edicion' : edc.numeroEdicion,
        //             'catedratico' : edc.catedratico,
        //             'estudiantes' : edc.cupoActual,
        //         }
        //     })

        //     return {
        //         'id' : crs.id,
        //         'imagen' : crs?.imageUrl,
        //         'nombre' : crs.nombre,
        //         'modalidad' : crs.modalidad,
        //         'codigo' : crs.codigoCurso,
        //         'certificacion' : crs.certificacion
        //     }
        // })
        
    //     setCursos(ecursos);

    // }   
    
    // const cursos = data.map((dataR: { id: string, imagen: string, nombre: string, tipoCurso: string, ediciones: [], professor: string, delegation: string, startDate: string }) => {

    //     return {
            
            // id: dataR.id,
            // imagen: dataR.imagen,
            // nombre: dataR.nombre,
            // delegation: dataR.delegation,
            // startDate: dataR.startDate,
            // professor: dataR.professor,
            // tipoCurso: dataR.tipoCurso,
            // ediciones: dataR.ediciones
            
    //     }
    // })

    const listaCursos = async () => {
        const responseCursos = await axios(url);
        const { data } = responseCursos;

        let ediciones = {};
        let cursos = [];

        cursos = data.map ((crs:any) => {
            ediciones = crs.ediciones.map( (edc:any) => {
                return {
                    id: edc.id,
                    numero: edc.numero,
                    current: edc.current,
                    startDate: edc.startDate  
                }
            })

            return {
                id: crs.id,
                imagen: crs.imagen,
                nombre: crs.nombre,
                delegation: crs.delegation,
                professor: crs.professor,
                tipoCurso: crs.tipoCurso,
                ediciones: crs.ediciones,
            }
        })
        
        
        setCursos(cursos);
    }
    
    const CursosItems = (dataR: { id: string, imagen: string, nombre: string, tipoCurso: string, professor: string, delegation: string, ediciones: [{ startDate: any, current: boolean, numero: number }] }) => {
        
        const urlR = `/reporte/edicion/${encodeURI(dataR.id)}`;

        const listMenu = dataR.ediciones.map (
            (obj) => {
                return (
                    <ul>
                        <li>
                            {obj.numero}
                        </li>
                    </ul>
                )
            }
        )

        return (

            <div className="portafolio_card" id={dataR.id}>
                <Link to={urlR}>
                    <div className="pcard_imagen"> <img src={dataR.imagen} alt={dataR.nombre} /></div>
                    <div className="pcard_tipoc"> <p className="mod_card_basica">{dataR.tipoCurso}</p></div>

                    <div className="pcard_area_central">
                        <div className="pcard_contenido">

                            <div className="pcard_edicion">
                                <p>-Edición en curso { dataR.ediciones[0].current == true ? dataR.ediciones[0].numero : "no hay ediciones activas"}</p>
                            </div>

                            <div className="pcard_titulo_curso">
                                <p className='titulo_curso' id='titulo_curso'>{dataR.nombre}</p>
                            </div>

                            <div className="card_info_curso">
                                <div className="pcard_estudiantes">
                                    <img src={icon_person} />
                                    <p>{dataR.professor}</p>
                                </div>
                                <div className="pcard_fecha">
                                    <img src={icon_calendar} />
                                    <p>{ calculoFechas(dataR.ediciones[0].startDate) } </p>
                                </div>
                            </div>
                                                
                            <div className="pcard_docentes">
                                <img src={icon_location} />
                                <p>Sede: {dataR.delegation}</p>
                            </div>

                        </div>

                        <div className="pcard_menu_ediciones">
                            <div className="listado_ediciones">
                                <p>Selecciona una edición</p>
                                
                                {listMenu}
                                
                            </div>
                        </div>
                    </div>

                    {/* <div className="pcard_contenido_publico">

                        <div className="pcard_contenido">

                            <div className="pcard_edicion">
                                <p>-Edición en curso { dataR.ediciones[0].current == true ? dataR.ediciones[0].numero : null }</p>
                            </div>

                            <div className="pcard_titulo_curso">
                                <p className='titulo_curso' id='titulo_curso'>{dataR.nombre}</p>
                            </div>

                            <div className="card_info_curso">
                                <div className="pcard_estudiantes">
                                    <img src={icon_person} />
                                    <p>{dataR.professor}</p>
                                </div>
                                <div className="pcard_fecha">
                                    <img src={icon_calendar} />
                                    <p>{ calculoFechas(dataR.ediciones[0].startDate) } </p>
                                </div>
                            </div>

                            <div className="pcard_docentes">
                                <img src={icon_location} />
                                <p>Sede: {dataR.delegation}</p>
                            </div>
                        </div>

                    </div> */}

                    <div className="pcard_linea"><span></span></div>
                </Link>
            </div>

        )
    }

    return (

        <>

            <RegionalBannerCentral/>

            <div className="portafolio_phome_area catalogo_servicios">
                <div id="hw_search" className="portafolio_htexto">
                    <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam sit amet egestas mauris. Cras molestie luctus libero ut posuere. Suspendisse nec risus consequat, convallis libero in, consequat felis. Maecenas ut tellus id odio pharetra accumsan vel a risus. Nunc hendrerit aliquam egestas. Curabitur fermentum congue justo non rutrum. Integer nunc massa, scelerisque ac ornare ac, ullamcorper et sem.                    </p>
                </div>

                <div className="portafolio_content">

                    {
                        curso.map((cursos: { id: string, imagen: string, nombre: string, tipoCurso: string, professor: string, delegation: string, ediciones: [{ startDate: any, current: boolean, numero: number }]  }) => (
                            <CursosItems {...cursos} />
                        ))
                    }

                </div>
            </div>

            <Footer/>
        </>

    );
});

